const Button = ({ type, disabled, width, icon, children, size, padding, className, ...props }) => {
	const enabledClass = "bg-black hover:bg-white text-white hover:text-black";
	const disabledClass = "bg-gray-300 text-gray-500 border-gray-300 cursor-not-allowed";
	return (
		<div className={`flex items-center}`} style={{ width: width ? width + "px" : "100%" }}>
			<button
				type={type}
				disabled={disabled}
				{...props}
				className={`text-${
					size ? size : "2xl"
				} font-semibold leading-4 ${disabled ? disabledClass : enabledClass} px-5 border border-black ${
					icon ? "rounded-s-xl" : "rounded-xl"
				} ${className}`}
				style={{ width: width ? width + "px" : "100%" }}
			>
				{children}
			</button>
			{icon && (
				<div className="border border-black py-2 px-2 rounded-e-xl">
					<img src={icon} alt="" />
				</div>
			)}
		</div>
	);
};

export default Button;
